<template>
  <div class="flex items-start gap-8">
    <div class="p-8">
      <RevSkeleton height="64px" shape="rectangle" width="64px" />
    </div>
    <div class="space-y-8 py-8">
      <RevSkeleton height="20px" shape="rectangle" width="136px" />
      <RevSkeleton height="12px" shape="rectangle" width="44px" />
      <RevSkeleton height="20px" shape="rectangle" width="92px" />
      <RevSkeleton height="12px" shape="rectangle" width="44px" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
